// The frame every Day Care screen renders inside. It reuses OT's OtScreen (the
// IPD theme, page header, loading / error states and render-crash boundary,
// per ADR-0008). Navigation lives in DaycareLayout's sidebar.

import React from "react";

import OtScreen from "../../ot/components/OtScreen";

export default function DaycareScreen({ children, ...screenProps }) {
  return (
    <OtScreen eyebrow="Day Care" {...screenProps}>
      {children}
    </OtScreen>
  );
}
